import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";
import { useT } from "@/lib/i18n";
import QualiopiBadge from "@/components/QualiopiBadge";

export default function Footer() {
  const t = useT();
  const col3 = [
    { label: t("nav.team"), path: "/equipe" },
    { label: t("nav.references"), path: "/references" },
    { label: t("nav.blog"), path: "/blog" },
    { label: t("nav.contact"), path: "/contact" },
  ];

  return (
    <footer data-testid="site-footer" className="relative bg-brand-deep text-white">
      <div className="h-1.5 gradient-bar" />
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-7">
            <img src="/brand/wedo_logo_2024.png" alt="WeDo" className="h-20 invert brightness-0 contrast-200 mb-8" />
            <p className="display text-2xl md:text-3xl leading-tight max-w-md">
              {t("footer.pitch")}
            </p>
            <Link to="/contact" data-testid="footer-cta" className="btn-pill btn-light mt-10">
              {t("common.cta.contact")}
            </Link>
          </div>

          <div className="md:col-span-5 md:pl-8">
            <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-accent-pink mb-4">{t("footer.colContact")}</p>
            <ul className="space-y-2.5">
              {col3.map(n => (
                <li key={n.path}>
                  <Link to={n.path} className="editorial-link text-[14px] text-white/90 hover:text-white">{n.label}</Link>
                </li>
              ))}
              <li>
                <a href="mailto:william@wedocoaching.com" className="editorial-link text-[14px] text-white/90 hover:text-white flex items-center gap-2">
                  <Mail size={14}/> william@wedocoaching.com
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/william-marques-coach/" target="_blank" rel="noreferrer" className="editorial-link text-[14px] text-white/90 hover:text-white flex items-center gap-2">
                  <Linkedin size={14}/> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Qualiopi — Certification officielle */}
        <div className="mt-16 pt-10 border-t border-white/10 flex justify-start">
          <QualiopiBadge variant="footer" />
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-white/85 tracking-wider">
            © {new Date().getFullYear()} WeDo Coaching & Conseil. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-6 flex-wrap">
            <Link to="/mentions-legales" data-testid="footer-legal-link" className="text-xs text-white/85 hover:text-white tracking-wider editorial-link">
              {t("footer.legal")}
            </Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-white/85 hover:text-white tracking-wider editorial-link">
              {t("footer.admin")}
            </Link>
            <Link to="/status" data-testid="footer-status-link" className="text-xs text-white/85 hover:text-white tracking-wider editorial-link inline-flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-lime animate-pulse" />
              Status
            </Link>
            <p className="text-xs text-white/85 tracking-[0.3em] uppercase display">make it matter.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
